import clearDayIcon from './clear-day.png';
import clearNightIcon from './clear-night.png';
import cloudyIcon from './cloudy.png';
import fogIcon from './fog.png';
import partlyCloudyDayIcon from './partly-cloudy-day.png';
import partlyCloudyNightIcon from './partly-cloudy-night.png';
import rainIcon from './rain.png';
import sleetIcon from './sleet.png';
import snowIcon from './snow.png';
import windIcon from './wind.png';
import defaultIcon from './fog.png';

export const getWeatherIcon = (iconName) => {
  switch (iconName) {
    case 'clear-day':
      return (clearDayIcon);
    case 'clear-night':
      return (clearNightIcon);
    case 'cloudy':
      return (cloudyIcon);
    case 'fog':
      return (fogIcon);
    case 'partly-cloudy-day':
      return (partlyCloudyDayIcon);
    case 'partly-cloudy-night':
      return (partlyCloudyNightIcon);
    case 'rain':
      return (rainIcon);
    case 'sleet':
      return (sleetIcon);
    case 'snow':
      return (snowIcon);
    case 'wind':
      return (windIcon);
    default:
      return (defaultIcon);
  }
};



// WEBPACK FOOTER //
// ./src/assets/weather/weather.js